__turbopack_context__.v({
  "buttonGroup": "ProductStrip-module-scss-module__ZTIibW__buttonGroup",
  "header": "ProductStrip-module-scss-module__ZTIibW__header",
  "heading": "ProductStrip-module-scss-module__ZTIibW__heading",
  "mini": "ProductStrip-module-scss-module__ZTIibW__mini",
  "root": "ProductStrip-module-scss-module__ZTIibW__root",
  "slide": "ProductStrip-module-scss-module__ZTIibW__slide",
  "swiper": "ProductStrip-module-scss-module__ZTIibW__swiper",
});
